import { __assign } from "tslib";
import Keycloak from 'keycloak-js';
//url: 'http://keycloak-server/auth',
export var keycloak = function (options) { return Keycloak(__assign({}, options)); };
//# sourceMappingURL=keycloak.js.map